// Polyfill for Amplify v6 — CRA doesn't provide `global` in browser
window.global = window;

// Catch unhandled promise rejections to prevent silent white-screen crashes
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  event.preventDefault(); // Prevent the browser from crashing the page
});
